import { TOnlineInterstitialCommunication } from "./onlineInterstitialCommunication.types";
import request from "src/utils/request";
import { getFromLocalStorage, setToLocalStorage } from "src/utils/localStorage";

const STORAGE_PREFIX = "online-interstitial-communication";
const SITE_TIMER_KEY = `${STORAGE_PREFIX}:site-started-at`;

function getEndpoint(language: string, layout: string | number) {
  const client = process.env.GATSBY_CONNECT_CLIENT;
  const baseUrl = process.env.GATSBY_CONNECT_URL;
  return `${baseUrl}/flamingo/online-interstitial-communication?client=${client}&language=${encodeURIComponent(language)}&layout=${encodeURIComponent(layout)}`;
}

export async function getOnlineInterstitialCommunications(language: string, layout: string | number): Promise<TOnlineInterstitialCommunication[]> {
  if (!layout) return [];
  const response: any = await request({
    url: getEndpoint(language, layout),
    method: "GET"
  });
  return Array.isArray(response?.data) ? response.data : [];
}

function getContentSignature(communication: TOnlineInterstitialCommunication) {
  const updatedAt = communication.date_updated || communication.updated_at;
  if (updatedAt) return updatedAt;

  return [
    communication.translations ? JSON.stringify(communication.translations) : "",
    communication.image?.id || communication.image?.filename_disk || "",
    communication.cta?.id || "",
  ].join(":");
}

export function getDismissalKey(communication: TOnlineInterstitialCommunication) {
  return `${STORAGE_PREFIX}:${communication.id}:${getContentSignature(communication)}`;
}

export function wasCommunicationSeen(communication: TOnlineInterstitialCommunication) {
  if (communication.dismissal_reset_strategy === "always") return false;

  return getFromLocalStorage(getDismissalKey(communication)) === true;
}

export function markCommunicationAsSeen(communication: TOnlineInterstitialCommunication) {
  setToLocalStorage(getDismissalKey(communication), true);
}

export function getSiteElapsedTimeMs() {
  if (typeof window === "undefined") return 0;

  const now = Date.now();
  const storedStartedAt = window.sessionStorage?.getItem(SITE_TIMER_KEY);
  const startedAt = storedStartedAt ? Number(storedStartedAt) : now;

  if (!storedStartedAt) window.sessionStorage?.setItem(SITE_TIMER_KEY, String(startedAt));
  if (!Number.isFinite(startedAt)) return 0;

  return Math.max(now - startedAt, 0);
}
